// NOTE: 使用時に随時追加してください。
export enum CodesEnum {
  // 役割区分
  ROLE_CATEGORY = '6',
  // ドキュメント種別
  DOCUMENT_TYPE = '7',
  // 取引ステータス
  TRANSACTION_STATUS = '11',
}

export enum ManagementCodesEnum {
  TRANSACTION_STATUS = 'TRANSACTION_STATUS',
}
